import React, { useEffect, useMemo, useRef, useState } from "react";
import { State } from "country-state-city";
import { getCountryCodeByName } from "../../Utils/countries";
import SelectField from "../SelectField";

interface StateSelectorProps {
  error?: string;
  value?: string;
  country?: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
}

const StateSelector = ({
  error,
  onChange,
  country,
  value,
  placeholder,
  className,
}: StateSelectorProps) => {
  const [localValue, setLocalValue] = useState("");
  const previousCountry = useRef(country);

  const countryCode = useMemo(
    () => getCountryCodeByName(country),
    [country]
  );

  const states = useMemo(
    () => (countryCode ? State.getStatesOfCountry(countryCode) : []),
    [countryCode]
  );

  useEffect(() => {
    setLocalValue(value ?? "");
  }, [value]);

  useEffect(() => {
    if (previousCountry.current !== country) {
      setLocalValue("");
      onChange("");
    }

    previousCountry.current = country;
  }, [country, onChange]);

  const handleChange = (nextValue: string) => {
    setLocalValue(nextValue);
    onChange(nextValue);
  };

  return (
    <SelectField
      showSearch
      error={error}
      value={localValue}
      disabled={!country}
      placeholder={placeholder ?? "Choose"}
      onChange={handleChange}
      label="State / Province"
      data={states.map((state) => ({ value: state.name }))}
      className={className}
    />
  );
};

export default StateSelector;
